/**
 * Which accounting integration to NAME in the UI.
 *
 * The server decides: check-user-session sends `billing_sync_provider` and
 * `billing_sync_provider_label`, computed by ActiveBillingProvider, which is
 * the same source the Timerlog reads on the web. The PWA's copy of that
 * payload did not carry them, which is why the "will not be transferred"
 * warning could only ever say Tripletex.
 *
 * The flag fallback below is for one real case: `Integrations` lives in
 * localStorage and survives a deploy, so the first load after this ships reads
 * a payload seeded before those keys existed. Deriving the name from the flags
 * keeps the warning correct until the next session refresh, in the same
 * priority order the server uses.
 */

const LABELS = {
  tripletex: 'Tripletex',
  poweroffice: 'PowerOffice',
  visma: 'Visma'
}

// Same order as ActiveBillingProvider::PRIORITY. Only one accounting
// integration may be on per tenant (D-POHRS-1), so this is determinism if the
// impossible state occurs, not a rule to lean on.
const PRIORITY = ['tripletex', 'poweroffice', 'visma']

export function anyBillingIntegrationEnabled (integrations) {
  const i = integrations || {}

  return PRIORITY.some(name => i[name] === 1)
}

export function billingProviderLabel (integrations) {
  const i = integrations || {}

  if (i.billing_sync_provider_label) {
    return i.billing_sync_provider_label
  }

  const named = String(i.billing_sync_provider || '').toLowerCase()
  if (LABELS[named]) {
    return LABELS[named]
  }

  const enabled = PRIORITY.find(name => i[name] === 1)

  return enabled ? LABELS[enabled] : null
}
